module.exports = __webpack_public_path__ + "be0d4acd6ba36cc94bd1a775fc9fe72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/metropolis/assets/menu.png
// module id = 2863
// module chunks = 0